var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading elevation-3"},[_c('h6',{staticClass:"mb-6"},[_vm._v("INHALTE WERDEN GELADEN")]),_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }